import { type TableConfig } from "@/types"
import { type ProjectOrganization } from "@/graphql/types"
import { i18n } from "@/i18n"
import { type MappedProjectOrganization } from "@/store/organization"

const config: TableConfig<ProjectOrganization, MappedProjectOrganization> = {
  columnDefs: [
    {
      key: "n",
      header: i18n.global.t("admin.traeger.felder.id.label"),
    },
    {
      key: "name",
      header: i18n.global.t("admin.traeger.felder.name.label"),
    },
    {
      key: "address.street",
      header: i18n.global.t("admin.traeger.felder.strasse.label"),
      active: false,
    },
    {
      key: "address.zipCode",
      header: i18n.global.t("admin.traeger.felder.plz.label"),
      active: false,
    },
    {
      key: "address.city",
      header: i18n.global.t("admin.traeger.felder.ort.label"),
      active: false,
    },
    {
      key: "address.district",
      header: i18n.global.t("admin.traeger.felder.ortsteil.label"),
      active: false,
    },
    {
      key: "address.country",
      format: (organization) =>
        organization.address?.country &&
        i18n.global.t(`countries_code.${organization.address?.country}`),
      header: i18n.global.t("admin.traeger.felder.land.label"),
      active: false,
    },
    {
      key: "numberOfMembers",
      header: i18n.global.t("admin.traeger.felder.numberOfMembers.label"),
      active: false,
    },
  ],
}

export default config
